/**
 * DD-DUE-24H-002 — weekday-hour due clock (port of rukh-pd-queue helpers).
 * Used for fixtures / pre-line display; live rows prefer server due_at.
 *
 * fmtDueDateTime omits year (reference parity) — sorting uses ISO.
 */
const HOUR_MS = 60 * 60 * 1000

/** Adds `hours` of weekday time — Sat/Sun hours do not count. No 9–5 clamp. */
export function addWeekdayHours(start: Date, hours: number): Date {
  const result = new Date(start)
  let remaining = hours
  while (remaining > 0) {
    result.setTime(result.getTime() + HOUR_MS)
    const dow = result.getDay()
    if (dow !== 0 && dow !== 6) remaining -= 1
  }
  return result
}

/** <30 minutes rounds down; >=30 rounds up. Local wall-clock minutes. */
export function roundToNearestHour(d: Date): Date {
  const result = new Date(d)
  result.setMinutes(0, 0, 0)
  if (d.getMinutes() >= 30) result.setTime(result.getTime() + HOUR_MS)
  return result
}

/** Reference fmtDueDateTime — "Jul 15, 2:00 PM" (no year). */
export function fmtDueDateTime(d: Date): string {
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

export function calcDueDateHours(iso: string): { display: string; iso: string } {
  const due = roundToNearestHour(addWeekdayHours(new Date(iso), 24))
  return { display: fmtDueDateTime(due), iso: due.toISOString() }
}

/** Apply a server/fixture due ISO to display fields. */
export function dueFieldsFromIso(iso: string): { dueDate: string; dueAtIso: string } {
  return { dueDate: fmtDueDateTime(new Date(iso)), dueAtIso: iso }
}

export function isOverdue(dueAtIso: string | undefined | null, nowMs: number = Date.now()): boolean {
  if (!dueAtIso) return false
  const t = Date.parse(dueAtIso)
  if (Number.isNaN(t)) return false
  return nowMs > t
}
